@let parametersetNameValue = parametersetName();
@let greenTableDesignValue = eppService.greenTableDesign();
@let colorMappingPerParametersetValue =
  eppService.colorMappingPerParameterset();
@let colorMappingsValue = eppService.colorMappings();

<div
  [ngClass]="
    dashboardView() ? 'matrix-timeline-dashboard' : 'matrix-table-wrapper'
  ">
  <!-- Fall A: Die große Standard-Tabelle auf der Produktseite bleibt unverändert -->
  @if (!dashboardView()) {
    <table class="matrix-table">
      @for (parameter of parameters(); track $index) {
        <tr>
          <td
            align="center"
            class="param-icon"
            [tp]="paramLegend"
            [tpData]="parameter"
            variation="popper"
            trigger="mouseenter"
            tpPlacement="right"
            [ngClass]="parameter | parameterColor">
            <ng-container appWmIcon [inputParameter]="parameter"></ng-container>
          </td>
          @for (element of tableData(); track $index) {
            @if (element.hasOwnProperty(parameter)) {
              <td
                [ngStyle]="
                  parametersetNameValue
                    | colorMapping
                      : parameter
                      : element[parameter]
                      : greenTableDesignValue
                      : colorMappingPerParametersetValue
                      : colorMappingsValue
                "
                [tp]="matrixTooltip"
                [tpData]="{
                  parameter: parameter,
                  epp: element[parameter],
                  dtg: element['valid_at'],
                }"
                variation="popper"
                trigger="mouseenter"
                tpPlacement="bottom"></td>
            }
          }
        </tr>
      }
    </table>
  }

  @if (dashboardView()) {
    @for (parameter of parameters(); track $index) {
      <div class="timeline-row">
        <div
          class="timeline-icon-zone"
          [tp]="paramLegend"
          [tpData]="parameter"
          [ngClass]="parameter | parameterColor"
          variation="popper"
          tpPlacement="right">
          <ng-container appWmIcon [inputParameter]="parameter"></ng-container>
        </div>

        <div class="timeline-bar">
          @for (element of tableData(); track $index) {
            @if (element.hasOwnProperty(parameter)) {
              <div
                class="timeline-segment"
                [ngStyle]="
                  parametersetNameValue
                    | colorMapping
                      : parameter
                      : element[parameter]
                      : greenTableDesignValue
                      : colorMappingPerParametersetValue
                      : colorMappingsValue
                "
                [tp]="matrixTooltip"
                [tpData]="{
                  parameter: parameter,
                  epp: element[parameter],
                  dtg: element['valid_at'],
                }"
                variation="popper"
                trigger="mouseenter"
                tpPlacement="bottom"></div>
            }
          }
        </div>
      </div>
    }
  }
</div>

<ng-template #matrixTooltip let-hide let-data="data">
  <table class="matrix-tooltip-table">
    <tr>
      <th class="tooltip-icon">
        <ng-container
          appWmIcon
          [inputParameter]="data.parameter"></ng-container>
      </th>
      <th>{{ 'METPARA_EPP.' + data.parameter | translate }}</th>
      <td align="center">
        <div
          class="table_indices"
          [ngStyle]="
            parametersetNameValue
              | colorMapping
                : data.parameter
                : data.epp
                : greenTableDesignValue
                : colorMappingPerParametersetValue
                : colorMappingsValue
          ">
          {{ data.epp }}
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="3">
        {{
          data.dtg
            | datex
              : 'dd DD.MM. HH:mm'
              : undefined
              : languageService.langSignal()
        }}
      </td>
    </tr>
    <tr>
      <td colspan="3">
        {{
          (parameterType() === 'index'
            ? 'MAPPING.INDEX.' + data.parameter + '.' + data.epp
            : 'MAPPING.CONDITION.' + data.epp
          ) | translate
        }}
      </td>
    </tr>
  </table>
</ng-template>

<ng-template #paramLegend let-hide let-parameter="data">
  <p>
    <strong>{{ 'METPARA_EPP.' + parameter | translate }}</strong>
  </p>
  @if (parameter | hasLegend) {
    <table class="legend-table">
      @for (
        row of parameter
          | getLegend
            : parametersetNameValue
            : greenTableDesignValue
            : colorMappingPerParametersetValue
            : colorMappingsValue;
        track $index
      ) {
        <tr>
          <td align="center" [ngStyle]="row['style']" width="40"></td>
          @if (row.hasOwnProperty('value')) {
            <td class="legend-value">
              <span>{{ row['value'] }}</span>
            </td>
          }
          @if (row.hasOwnProperty('text')) {
            <td>
              <span>{{ 'MAPPING.' + row['text'] | translate }}</span>
            </td>
          }
          @if (row.hasOwnProperty('text2')) {
            <td>
              <span>{{ 'MAPPING.' + row['text2'] | translate }}</span>
            </td>
          }
        </tr>
      }
    </table>
  }
</ng-template>
